var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1693_6199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.221 11.6408L17.8928 10.4314C17.6975 10.169 17.5705 9.85829 17.5512 9.53159C17.4814 8.33754 17.7074 8.03009 17.2317 6.79534C16.3242 4.44024 14.3029 2.68794 11.8197 2.23639C6.78609 1.32009 2.40259 5.16239 2.40259 10.0282C2.40259 11.7849 2.97679 13.4052 3.94534 14.7181C4.54154 15.526 4.88309 16.4924 4.88309 17.4961V20.8192C4.88309 21.4165 5.36709 21.9005 5.96439 21.9005H11.7674C12.3647 21.9005 12.8487 21.4165 12.8487 20.8192V18.8024H15.8941C16.6833 18.8024 17.3582 18.2342 17.4924 17.4565L17.6761 16.3923L16.6597 15.7202C16.2923 15.4776 16.3715 14.9172 16.7917 14.7857L17.9335 14.4277L17.9417 13.507L19.204 12.4559C19.4559 12.2458 19.4647 11.8619 19.2221 11.6408H19.221Z",
    fill: "#333D4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5558 16.9154C21.5206 16.9154 21.4849 16.911 21.4486 16.9016L20.1379 16.5502C19.9179 16.4913 19.7876 16.2647 19.8464 16.0447C19.9053 15.8253 20.1319 15.696 20.3519 15.7532L21.6625 16.1047C21.8825 16.1635 22.0129 16.3901 21.954 16.6101C21.9045 16.7944 21.7379 16.9154 21.5558 16.9154Z",
    fill: "#ABB7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9925 18.836C20.9226 18.836 20.8517 18.8184 20.7862 18.7804L19.6109 18.1023C19.4134 17.9884 19.3463 17.736 19.4602 17.5391C19.574 17.3416 19.8265 17.274 20.0234 17.3884L21.1987 18.0665C21.3962 18.1804 21.4633 18.4328 21.3494 18.6297C21.273 18.7623 21.1349 18.836 20.9925 18.836Z",
    fill: "#ABB7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0281 14.97H20.6713C20.4436 14.97 20.2588 14.7852 20.2588 14.5575C20.2588 14.3298 20.4436 14.145 20.6713 14.145H22.0281C22.2558 14.145 22.4406 14.3298 22.4406 14.5575C22.4406 14.7852 22.2558 14.97 22.0281 14.97Z",
    fill: "#ABB7C7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1693_6199"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotice);
export default __webpack_public_path__ + "static/media/notice.038cf778be2dcb041502c5dfd4d993c1.svg";
export { ForwardRef as ReactComponent };